/* CheckboxRenderer.js */

"use strict";

//const _ = require("lodash");

class CheckboxRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("checkbox-column");
        this._rootElem.component = this._model;
        this._statusIcon = document.createElement("base-icon-gl");
        this._registerListeners();
        this.render();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }
    _registerListeners() {
        this._model.on("Checkbox", (this._onCheckbox = this._onCheckbox.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeAllListeners("Checkbox");
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setCheckbox(this._model.getValue());
            resolve();
        });
        return prom;
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onCheckbox(newVal) {
        this._setCheckbox(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _setCheckbox(newVal) {
        if (newVal === true) {
            this._statusIcon.dataset.icon = "common.check";
            this._rootElem.appendChild(this._statusIcon);
        } else {
            this._rootElem.innerHTML = "";
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = CheckboxRenderer;
